import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from "react-router-dom";
import { getApi } from '../../api/endpoints.js';
import Page from "../Page.js";
import FormPartial from "./FormPartial.js";
import PageContentWrapper from "../../components/PageContentWrapper.js";
import uiManager from '../../../config/ui.js';
import PAGES from '../../data/PagesConstants.js';
import ComplaintCategory from '../../models/ComplaintCategory.js';
import { toast } from 'react-toastify';


const Edit = (props) => {
  const [complaintCategory, setComplaintCategory] = useState((new ComplaintCategory()).toStateJson());
  const [fetchApi] = getApi('showCategory');
  const [updateApi] = getApi('updateCategory');
  const navigate = useNavigate();
  const params = useParams();
  let complaintCategoryObj = new ComplaintCategory();

  useEffect(() => {
    getRecord({ id: params.id });
  }, []);

  const getRecord = async (params) => {
    try {
      let response = await fetchApi({ id: params.id }).unwrap();
      setComplaintCategory((new ComplaintCategory(response.data.category)).toStateJson());
    } catch (error) {
      toast.error("Something Went Wrong !");
        }
  }

  const updateRecord = async (params) => {
    try {
      await updateApi(params).unwrap();
      navigate("/categories");
      toast.success("Updated Successfully.");
    } catch (error) {
      complaintCategoryObj.set_api_errors(error.data.data.errors);
    }
  }

  const onUpdateClick = () => {
    try{
      updateRecord((new ComplaintCategory(complaintCategory)).toApiJson());
    } catch(error){
      setComplaintCategory(new ComplaintCategory(complaintCategory));
    }
  }

  const onBackClick = () => {
    navigate("/categories");
  }

  return <Page
    uiPage={uiManager.getUiPage(PAGES.EditComplaintCategoryPage.name)}
    breadcrumbs={[{ label: "Home", url: '/dashboard' }, { label: "Categories", url: '/categories' }, { label: "Edit Category" }]}
    className={'complaintCategories-edit-page'}
  >
    <PageContentWrapper contentHeading={"Edit Category"}>
      <div className='m-3'>
        <form className="row g-4" autoComplete="off">
          <FormPartial complaintCategory={complaintCategory} setComplaintCategory={setComplaintCategory} />
          <div className='mb-4 col-md-12'>
            <div>
              <button type="button" className="btn btn-voltup-theme" onClick={onBackClick} style={{ float: 'inline-start' }}>
                Back
              </button>
              <button type="button" className="btn btn-voltup-theme ms-3" onClick={onUpdateClick}>
                Update Category
              </button>
            </div>
          </div>
        </form>
      </div>
    </PageContentWrapper>
  </Page>
};

export default Edit;
